export default __webpack_public_path__ + "static/media/businessDeal.f300ab47.png";